import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TmsWebBaseEditCreateService } from 'tms-web-shared';
import { ProcessRouteItem } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ProcessRouteItemService extends TmsWebBaseEditCreateService<ProcessRouteItem, ProcessRouteItem> {
  constructor() {
    super('ProcessRouteItem', $localize`Process Route Step`);
  }

  getForProcessRoute(processRouteHeaderId: string): Observable<ProcessRouteItem[]> {
    return this.httpService.get<ProcessRouteItem[]>(`${this.apiUrl}/ProcessRoute/${processRouteHeaderId}`);
  }
}
